import React, { useEffect, useState } from 'react'
import { Form, Button } from 'react-bootstrap'
import axios from 'axios'
import { sanitizeSearchQuery } from '../utils/sanitize'

const SearchBox = ({ history }) => {
  const [keyword, setKeyword] = useState('')
  const [maxLen, setMaxLen] = useState(128)
  const [error, setError] = useState('')

  useEffect(() => {
    let mounted = true
    axios.get('/api/products/max-name-length', { withCredentials: true })
      .then(res => {
        if (!mounted) return
        const v = Number(res?.data?.maxNameLength) || 0
        setMaxLen(Math.min(Math.max(v, 32), 256))
      })
      .catch(() => {})
    return () => { mounted = false }
  }, [])

  const cleanValue = sanitizeSearchQuery(keyword, maxLen)
  const canSubmit = Boolean(cleanValue)

  const submitHandler = (e) => {
    e.preventDefault();
    e.stopPropagation(); // Prevent event bubbling
    
    const clean = sanitizeSearchQuery(keyword, maxLen);
    if (!clean || clean.length === 0) {
      setError('Please enter a search term');
      return;
    }
    
    setError('');
    const encodedKeyword = encodeURIComponent(clean);
    
    // Force navigation even if already on search page
    const currentPath = history.location.pathname;
    const targetPath = `/search/${encodedKeyword}`;
    
    if (currentPath === targetPath) {
      // Same search - force reload by adding timestamp
      history.push(`${targetPath}?t=${Date.now()}`);
    } else {
      history.push(targetPath);
    }
  }

  return (
    <Form className='d-flex align-items-center justify-content-center searchbox-form' onSubmit={submitHandler}>
      <Form.Control
        type='text'
        name='q'
        value={keyword}
        maxLength={maxLen}
        required
        onChange={(e) => {
          const v = e.target.value
          setKeyword(v.length > maxLen ? v.slice(0, maxLen) : v)
          if (error) setError('')
        }}
        placeholder='Search products...'
        className='searchbox-input'
        aria-label='Search products'
        aria-invalid={!canSubmit && keyword.length > 0 ? true : undefined}
        aria-describedby='searchbox-help'
      />
      {keyword.length > 0 && !canSubmit && (
        <small id='searchbox-help' className='text-warning ms-2' role='alert'>
          Please enter valid search terms (letters, numbers, or common punctuation)
        </small>
      )}
      {error && (
        <small id='searchbox-help' role='alert' className='text-danger ms-2'>
          {error}
        </small>
      )}
      <Button
        type='submit'
        variant='primary'
        className='searchbox-btn'
        disabled={!canSubmit}
        aria-disabled={!canSubmit}
        title={!canSubmit ? 'Please enter a search term' : undefined}
        onClick={(e) => {
          // Explicit handler to ensure search always triggers
          if (!canSubmit) {
            e.preventDefault();
            setError('Please enter a search term');
            return;
          }
          // Let form submission handle the actual navigation
        }}
      >
        Search
      </Button>
    </Form>
  )
}

export default SearchBox
